import { createContext, Dispatch, SetStateAction } from 'react';

interface SignInContextProps {
    useVerified: [boolean, Dispatch<SetStateAction<boolean>>];
    usePhoneNo: [string, Dispatch<SetStateAction<string>>]
    useInputPhoneNo: [string, Dispatch<SetStateAction<string>>];
    useInputSmsAuthCode: [string, Dispatch<SetStateAction<string>>];
}

const SignInContext = createContext<SignInContextProps>({} as SignInContextProps);

export default SignInContext;
